module.exports = __webpack_public_path__ + "static/img/11.980e2a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/11.png
// module id = bYuR
// module chunks = 0